import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWindows95Component } from './simple-icons-windows95.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWindows95Component ],
    exports:      [ SimpleIconsWindows95Component ],
    bootstrap:    []
})
export class SimpleIconsWindows95Module {}
